export const KyrgyzstanCities = [
  {
    id: 1,
    city_name: 'Ош',
    country_code: 'KG',
    country_name: 'Ошская область',
    available: false,
  },
  {
    id: 2,
    city_name: 'Балыкчы',
    country_code: 'KG',
    country_name: 'Иссык-Кульская область',
    available: false,
  },
  // {
  //   id: 3,
  //   city_name: 'Чолпон-Ата',
  //   country_code: 'KG',
  //   country_name: 'Иссык-Кульская область',
  //   available: false,
  // },
  {
    id: 4,
    city_name: 'Тюп',
    country_code: 'KG',
    country_name: 'Иссык-Кульская область',
    available: false,
  },
  {
    id: 5,
    city_name: 'Ананьево',
    country_code: 'KG',
    country_name: 'Иссык-Кульская область',
    available: false,
  },
  {
    id: 6,
    city_name: 'Кызыл-Суу',
    country_code: 'KG',
    country_name: 'Иссык-Кульская область',
    available: false,
  },
  {
    id: 7,
    city_name: 'Боконбаево',
    country_code: 'KG',
    country_name: 'Иссык-Кульская область',
    available: false,
  },
]
